(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-editorial"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (window.innerWidth > 768) return;
     // mobile/tablet only

    const container = document.querySelector('.collapsible-text-area');
    if (! container) return;
    

// Target BOTH <p> and <li> but treat them the same logic
    const targets = container.querySelectorAll('p, li');

    targets.forEach((item) => {
      const lineHeight = parseInt(window.getComputedStyle(item).lineHeight, 10);
      const maxHeight = lineHeight * 3;

// Expand temporarily to measure
      item.style.maxHeight = 'unset';

      if (item.scrollHeight > maxHeight) {
        item.classList.add('collapsible-text');

// Create toggle button once
        const toggleBtn = document.createElement('button');
        toggleBtn.className = 'readmore-toggle';
        toggleBtn.innerText = '...read more';

        toggleBtn.addEventListener('click', () => {
          item.classList.toggle('expanded');
          toggleBtn.innerText = item.classList.contains('expanded')
            ? 'show less'
            : '...read more';
        });

// Insert after each expandable element
        item.insertAdjacentElement('afterend', toggleBtn);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-image-text"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const descriptions = document.querySelectorAll('[data-cit]');

    descriptions.forEach((wrapper) => {
      const textEl = wrapper.querySelector('[data-feature-text]');
      const toggle = wrapper.querySelector('[data-feature-toggle]');

      if (!textEl || !toggle) return;

      const updateState = () => {
        const isExpanded = wrapper.classList.contains('expanded');
        const isTruncated = !isExpanded && textEl.scrollHeight > textEl.clientHeight + 1;
        const shouldShowToggle = isTruncated || isExpanded;

        wrapper.classList.toggle('has-toggle', shouldShowToggle);
        toggle.hidden = !shouldShowToggle;

        if (!isExpanded && !isTruncated) {
          toggle.textContent = 'See more';
          toggle.setAttribute('aria-expanded', 'false');
        }
      };

      updateState();
      window.addEventListener('resize', updateState);

      toggle.addEventListener('click', () => {
        const isExpanded = wrapper.classList.toggle('expanded');
        toggle.textContent = isExpanded ? 'See less' : 'See more';
        toggle.setAttribute('aria-expanded', isExpanded);
        updateState();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordion-2"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const faqItems = document.querySelectorAll('.faq-item');

    faqItems.forEach((item) => {
      const question = item.querySelector('.faq-question');
      const answer = item.querySelector('.faq-answer');

      question.addEventListener('click', () => {
        // Close others
        faqItems.forEach((i) => {
          if (i !== item) {
            i.classList.remove('active');
            i.querySelector('.faq-answer').style.maxHeight = null;
          }
        });

        // Toggle clicked item
        item.classList.toggle('active');
        if (item.classList.contains('active')) {
          answer.style.maxHeight = answer.scrollHeight + 'px';
        } else {
          answer.style.maxHeight = null;
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-lifestyle-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const descriptions = document.querySelectorAll('[data-feature-description]');

    descriptions.forEach((wrapper) => {
      const textEl = wrapper.querySelector('[data-feature-text]');
      const toggle = wrapper.querySelector('[data-feature-toggle]');

      if (!textEl || !toggle) return;

      const updateState = () => {
        const isExpanded = wrapper.classList.contains('expanded');
        const isTruncated = !isExpanded && textEl.scrollHeight > textEl.clientHeight + 1;
        const shouldShowToggle = isTruncated || isExpanded;

        wrapper.classList.toggle('has-toggle', shouldShowToggle);
        toggle.hidden = !shouldShowToggle;

        if (!isExpanded && !isTruncated) {
          toggle.textContent = 'See more';
          toggle.setAttribute('aria-expanded', 'false');
        }
      };

      updateState();
      window.addEventListener('resize', updateState);

      toggle.addEventListener('click', () => {
        const isExpanded = wrapper.classList.toggle('expanded');
        toggle.textContent = isExpanded ? 'See less' : 'See more';
        toggle.setAttribute('aria-expanded', isExpanded);
        updateState();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hst-follow"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================
   hst-follow — reel playback ONLY.
   The reveal observer, the header state and the counters all belong to
   assets/hst-common.js and are NOT reimplemented here.

   Why any script: the reels ship `preload="none"` so they never compete with
   the posters for bandwidth. A reel with no <source> (the design's own rest
   state, and the out-of-the-box render) is skipped entirely — its poster is
   what the design shows. Everything is wrapped in try/catch because Shopify
   concatenates every section's JS into ONE bundle, so an uncaught throw here
   would kill every section after it.
   ========================================================================== */
(function () {
  'use strict';

  var SEL = '[data-hst-follow-video]';
  var reduce = false;
  try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  function hasSource(v) {
    try {
      if (v.currentSrc) return true;
      if (v.getAttribute('src')) return true;
      return v.querySelectorAll('source[src]').length > 0;
    } catch (e) { return false; }
  }

  function play(v) {
    try {
      v.muted = true;
      if (v.preload === 'none') { v.preload = 'metadata'; }
      var p = v.play();
      if (p && typeof p.catch === 'function') {
        p.catch(function () { /* blocked by policy — the poster stays */ });
      }
    } catch (e) {}
  }

  function pause(v) {
    try { v.pause(); } catch (e) {}
  }

  var io = null;
  function observer() {
    if (io || !window.IntersectionObserver) return io;
    io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var e = entries[i];
        if (e.isIntersecting) { play(e.target); } else { pause(e.target); }
      }
    }, { threshold: 0.4 });
    return io;
  }

  function boot(root) {
    try {
      if (reduce) return;
      var scope = (root && root.querySelectorAll) ? root : document;
      var list = scope.querySelectorAll(SEL);
      var obs = observer();
      for (var i = 0; i < list.length; i++) {
        var v = list[i];
        if (v.getAttribute('data-hst-follow-bound') === '1') continue;
        if (!hasSource(v)) continue;
        v.setAttribute('data-hst-follow-bound', '1');
        if (obs) { obs.observe(v); } else { play(v); }
      }
    } catch (e) {}
  }

  function ready() { boot(document); }

  if (document.readyState === 'complete' || document.readyState === 'interactive') ready();
  else document.addEventListener('DOMContentLoaded', ready, { once: true });
  window.addEventListener('load', ready, { once: true });

  /* Theme editor: a re-rendered section arrives with fresh, unbound reels. */
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target || document);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    try {
      if (!io || !e.target || !e.target.querySelectorAll) return;
      var list = e.target.querySelectorAll(SEL);
      for (var i = 0; i < list.length; i++) { io.unobserve(list[i]); }
    } catch (err) {}
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hst-hero"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================
   hst-hero — media bootstrap ONLY.
   The entrance animation, the reveal observer and the header state all belong
   to assets/hst-common.js and are NOT touched here.

   Why any script at all: the <video> ships `preload="none"` so it cannot
   compete with the poster for bandwidth during LCP. Something has to hand it
   a network request afterwards. Everything is wrapped in try/catch because
   Shopify concatenates every section's JS into ONE bundle — an uncaught throw
   here would kill every section that follows (README §5.6).
   ========================================================================== */
(function () {
  'use strict';

  var reduce = false;
  try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  function start(video) {
    try {
      if (!video || video.getAttribute('data-hst-hero-started') === '1') return;
      video.setAttribute('data-hst-hero-started', '1');
      /* Reduced motion: leave the poster in place, never autoplay. */
      if (reduce) return;
      video.preload = 'auto';
      video.muted = true;                 /* required for programmatic play */
      video.load();
      var play = function () {
        var p = video.play();
        if (p && typeof p.catch === 'function') {
          p.catch(function () { /* blocked by policy — the poster stays */ });
        }
      };
      if (video.readyState >= 3) play();
      else video.addEventListener('canplay', play, { once: true });
    } catch (e) {}
  }

  /* The carousel owns slide 1's video once slide 1 is not the opening slide.
     Handing `start` over rather than reimplementing it keeps the preload,
     autoplay-policy and "already started" handling in exactly one place. */
  window.__hstHeroStartVideo = start;

  /* Slide 1's background video is several megabytes. When another slide opens
     the carousel it is behind an opaque layer, so fetching it now would spend
     the visitor's bandwidth on frames nobody can see. `show()` calls `start`
     the moment slide 1 actually comes round. */
  function wanted(video) {
    try {
      var hero = video.closest ? video.closest('[data-hst-hero]') : null;
      return !hero || hero.getAttribute('data-hst-base-on') !== 'false';
    } catch (e) { return true; }
  }

  function boot(root) {
    try {
      var scope = (root && root.querySelectorAll) ? root : document;
      var list = scope.querySelectorAll('[data-hst-hero-video]');
      for (var i = 0; i < list.length; i++) { if (wanted(list[i])) start(list[i]); }
      if (root && root.matches && root.matches('[data-hst-hero-video]') && wanted(root)) start(root);
    } catch (e) {}
  }

  function idle(fn) {
    if (window.requestIdleCallback) window.requestIdleCallback(fn, { timeout: 2000 });
    else window.setTimeout(fn, 200);
  }

  function ready() { idle(function () { boot(document); }); }

  if (document.readyState === 'complete') ready();
  else window.addEventListener('load', ready, { once: true });

  /* Theme editor: a re-rendered section arrives with a fresh, unstarted video. */
  document.addEventListener('shopify:section:load', function (e) {
    idle(function () { boot(e.target || document); });
  });
})();

  /* ---- hero slides ------------------------------------------------------
     Only runs when a merchant has actually added a `slide` block. Slide 0 is
     the section's own content; slides 1..n are the overlays.

     Videos on extra slides carry `data-hst-xsrc` and no `src`, so nothing is
     fetched until that slide is first shown — the whole point of a carousel
     that lives inside the LCP element.                                      */
  (function () {
    var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

    function initSlides(root) {
      var xs = root.querySelectorAll('.hst-hero__xslide');
      if (!xs.length) return;
      var dots = root.querySelectorAll('.hst-hero__dot');
      /* Every slide's copy lives in the SAME `.hst-hero__in`; only one is ever
         un-hidden. `hidden` (not opacity) so the inactive slides' links leave
         the tab order and the accessibility tree instead of sitting invisible
         on top of the active one. */
      var copies = root.querySelectorAll('[data-hst-copy]');
      var base = root.querySelector('.hst-hero__in > .hst-hero__copy:not(.hst-hero__xcopy)');
      var basevid = root.querySelector('[data-hst-hero-video]');
      var total = xs.length + 1;

      /* ---- carousel position -> slide -----------------------------------
         Slide 1 (the section's own content) is no longer pinned to position 0:
         `base_position` can drop it anywhere in the sequence so a block — a
         campaign banner, say — can open the carousel.

         `order[n]` is the slide shown at position n: -1 for slide 1, otherwise
         a 0-based index into `xs`. Building the table once here keeps `show()`
         a lookup rather than an arithmetic special case, and it stays in step
         with the Liquid that printed the initial `is-on` because both derive
         from the same clamped `base_pos`.                                    */
      var bp = parseInt(root.getAttribute('data-hst-base-pos'), 10) || 1;
      if (bp < 1) bp = 1;
      if (bp > total) bp = total;
      var order = [];
      for (var q = 0, xi = 0; q < total; q++) order.push(q === (bp - 1) ? -1 : xi++);

      var i = 0, timer = null, paused = false;

      function show(n) {
        n = ((n % total) + total) % total;
        i = n;
        var cur = order[n];                      /* -1 => slide 1 */
        root.setAttribute('data-hst-active', String(n));
        for (var k = 0; k < xs.length; k++) {
          var on = k === cur;
          xs[k].classList.toggle('is-on', on);
          xs[k].setAttribute('aria-hidden', on ? 'false' : 'true');
          var v = xs[k].querySelector('.hst-hero__xvideo');
          if (v) {
            if (on) {
              if (!v.src && v.dataset.hstXsrc) v.src = v.dataset.hstXsrc;
              var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
            } else if (!v.paused) { v.pause(); }
          }
        }
        if (base) base.hidden = (cur !== -1);
        /* Slide 1's background video, started lazily and paused off-slide for
           the same reason the extra slides' videos are. `data-hst-base-on` is
           what tells the media bootstrap to leave it alone until now. */
        root.setAttribute('data-hst-base-on', cur === -1 ? 'true' : 'false');
        if (basevid) {
          if (cur === -1) {
            if (window.__hstHeroStartVideo) window.__hstHeroStartVideo(basevid);
            if (basevid.paused && basevid.readyState >= 2) {
              var bp2 = basevid.play(); if (bp2 && bp2.catch) bp2.catch(function () {});
            }
          } else if (!basevid.paused) { basevid.pause(); }
        }
        /* `data-hst-copy` is the block's 1-based loop index, so the copy that
           belongs to xs[cur] is numbered cur + 1. On slide 1 (cur === -1) that
           evaluates to 0, which no copy carries — so they all hide, which is
           the correct outcome rather than a coincidence worth guarding. */
        for (var c = 0; c < copies.length; c++) {
          copies[c].hidden = parseInt(copies[c].getAttribute('data-hst-copy'), 10) !== (cur + 1);
        }
        for (var d = 0; d < dots.length; d++) {
          dots[d].classList.toggle('is-on', d === n);
          dots[d].setAttribute('aria-selected', d === n ? 'true' : 'false');
        }
      }

      var ms = parseInt(root.getAttribute('data-hst-interval'), 10) || 6000;
      var auto = root.getAttribute('data-hst-autoplay') === 'true';
      function tick() { if (!paused) show(i + 1); }
      function start() { if (auto && !timer && !REDUCED.matches) timer = setInterval(tick, ms); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      for (var d = 0; d < dots.length; d++) {
        dots[d].addEventListener('click', function (e) {
          show(parseInt(e.currentTarget.getAttribute('data-hst-goto'), 10) || 0);
          stop(); start();                       /* restart the clock on intent */
        });
      }
      root.addEventListener('pointerenter', function () { paused = true; });
      root.addEventListener('pointerleave', function () { paused = false; });
      root.addEventListener('focusin', function () { paused = true; });
      root.addEventListener('focusout', function () { paused = false; });

      /* A hero scrolled off screen should not be swapping slides or decoding
         video frames. */
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (en) { en.isIntersecting ? start() : stop(); });
        }, { threshold: 0.15 }).observe(root);
      } else { start(); }

      /* ---- swipe -----------------------------------------------------------
         Touch events rather than pointer events: they exist on every touch
         browser, and they cannot be confused with a mouse drag, which is not a
         swipe and must keep selecting text.

         EVERY LISTENER IS PASSIVE. Nothing here calls preventDefault on a
         touch, so the browser never waits on this code to decide whether the
         page scrolls — vertical scrolling stays on the compositor and is not
         slowed down by the carousel existing. The horizontal gesture is claimed
         declaratively instead, with `touch-action: pan-y pinch-zoom` in the
         stylesheet: the browser keeps vertical panning and pinch-zoom, and
         hands us everything horizontal.

         A gesture only counts as a swipe when it is BOTH past the distance
         threshold and more horizontal than vertical. Without the second test a
         diagonal flick while scrolling the page changes the slide, which feels
         like the hero grabbing at the finger.                                */
      if (total > 1) {
        var tX = 0, tY = 0, tracking = false, swiped = false;
        var SWIPE_MIN = 40;                       /* px of horizontal travel */

        root.addEventListener('touchstart', function (e) {
          if (e.touches.length !== 1) { tracking = false; return; }  /* pinch */
          tracking = true;
          swiped = false;
          tX = e.touches[0].clientX;
          tY = e.touches[0].clientY;
        }, { passive: true });

        root.addEventListener('touchend', function (e) {
          if (!tracking) return;
          tracking = false;
          var t = e.changedTouches && e.changedTouches[0];
          if (!t) return;
          var dx = t.clientX - tX;
          var dy = t.clientY - tY;
          if (Math.abs(dx) < SWIPE_MIN || Math.abs(dx) <= Math.abs(dy)) return;
          swiped = true;
          show(dx < 0 ? i + 1 : i - 1);           /* left = forward */
          stop(); start();                        /* restart the clock */
        }, { passive: true });

        root.addEventListener('touchcancel', function () {
          tracking = false;
        }, { passive: true });

        /* A swipe that ends over the full-bleed slide link would otherwise be
           delivered as a click and navigate away. Capture phase, so this runs
           before the anchor's own handler and before the default action. The
           flag is cleared here rather than on a timer: exactly one click can
           follow a touch sequence. */
        root.addEventListener('click', function (e) {
          if (!swiped) return;
          swiped = false;
          e.preventDefault();
          e.stopPropagation();
        }, true);
      }

      show(0);
    }

    function boot(scope) {
      (scope || document).querySelectorAll('[data-hst-hero]').forEach(function (r) {
        if (r.__hstSlides) return;
        r.__hstSlides = true;
        initSlides(r);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
    else boot();
    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hst-newsletter"]) return;
  try {
    
/* ==========================================================================
   hst-newsletter — submit, open/close, frequency, and the keyboard-safe stage.

   Wrapped in try/catch throughout: Shopify concatenates every section's JS into
   ONE bundle, so an uncaught throw here would take out every section after it.
   ========================================================================== */
(function () {
  'use strict';

  var KEY = 'hst-nl-state';
  /* Written immediately before the script hands over to a REAL form submit, and
     read once on the way back. It is what tells this popup that the
     `customer_posted=true` it is looking at belongs to ITS form and not to the
     footer signup — Shopify sets that flag for the page, not for one form. */
  var PENDING = 'hst-nl-pending';

  function readState() {
    try {
      var raw = window.localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : {};
    } catch (e) { return {}; }          /* private mode, blocked storage */
  }
  function writeState(v) {
    try { window.localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {}
  }
  function session(k, v) {
    try {
      if (v === undefined) return window.sessionStorage.getItem(k);
      if (v === null) { window.sessionStorage.removeItem(k); return null; }
      window.sessionStorage.setItem(k, v);
      return v;
    } catch (e) { return null; }
  }
  function days(n) { return n * 86400000; }

  function boot(scope) {
    var els = (scope || document).querySelectorAll('[data-hst-nl]');
    for (var i = 0; i < els.length; i++) init(els[i]);
  }

  function init(dlg) {
    try {
      if (dlg.__hstNl) return;
      dlg.__hstNl = true;
      if (typeof dlg.showModal !== 'function') return;   /* no <dialog> support */

      var d = dlg.dataset;
      var opener = null;
      var timer = null;

      /* ---- the dialog follows the visible viewport ------------------------
         When the on-screen keyboard opens, the LAYOUT viewport does not
         change — only the VISUAL one does. The dialog is the element being
         sized (not the stage inside it) so that there is exactly one box and
         one coordinate system; see the long note at the top of the stylesheet
         for why the old two-box arrangement made the sheet land high and then
         drop. `has-vv` is what arms the CSS rule, and it is only added once
         both properties have actually been written. */
      function syncStage() {
        try {
          var vv = window.visualViewport;
          if (!vv) return;

          var h = vv.height;
          var t = vv.offsetTop;

          /* REFUSE A NONSENSE MEASUREMENT rather than freezing it on. An
             Android WebView that has not finished its first layout pass when
             the delay timer fires can report height 0; writing that would set
             the dialog to a zero-height box and the popup would simply never
             be seen again on that page view. */
          if (!(h > 0) || !isFinite(t)) return;

          /* THE GEOMETRY IS WRITTEN UNCONDITIONALLY, AND THAT IS THE FIX FOR A
             SECOND "STUCK TO THE TOP".

             The pinch-zoom guard below used to sit HERE, above these two
             writes. That made the escape hatch worse than the thing it was
             guarding: `.has-vv` is armed for the life of the page and it drives
             the dialog's own `top` and `height`, so any stale value stays on
             screen until some later un-guarded event happens to correct it. The
             sequence that bit: the shopper focuses the field, the keyboard
             takes the viewport down to ~350px and that height is written; the
             keyboard closes while the page is zoomed even slightly, so the
             correcting call returns early and writes nothing; the dialog is
             left as a 350px box at top:0 — the sheet, pinned to the bottom of
             a box that only covers the top of the screen. That reads as "stuck
             to the top" on a perfectly modern phone, with no old engine
             involved.

             Writing every time is also simply more correct: a zoomed visual
             viewport still describes exactly the strip the shopper can see, so
             tracking it keeps the popup filling that strip. */
          dlg.style.setProperty('--hst-nl-stage-h', h + 'px');
          dlg.style.setProperty('--hst-nl-stage-top', t + 'px');
          dlg.classList.add('has-vv');

          /* ONLY THE COMPACT DECISION IS SUPPRESSED WHILE ZOOMED. That was the
             real complaint the guard was added for: visualViewport reports the
             ZOOMED window, so a pinch to 1.5x on a 745px viewport reads as 497
             and tripped the `< 520` threshold — the shopper who pinched in to
             read the fine print watched the compact layout delete it. The
             threshold is about how much room there is, and a magnified view has
             not actually lost any. */
          if ((vv.scale || 1) > 1.01) return;

          /* Only while it is open. Toggling the compact layout on a closed
             dialog is wasted work, and toggling it DURING the entrance would
             change the card's padding and type size mid-slide — a second,
             smaller version of the jump this file exists to remove. */
          if (dlg.open && !dlg.classList.contains('is-entering')) {
            dlg.classList.toggle('is-compact', h < 520);
          }
        } catch (e) {}
      }
      /* BOUND ON OPEN, RELEASED ON CLOSE — not at init. These used to be
         attached for the life of every page view, including the overwhelming
         majority where the popup is suppressed and never appears. On iOS they
         fire on every URL-bar collapse and every pinch-pan, and each call wrote
         two inline custom properties and a class onto a `display:none` dialog:
         style invalidation on every scroll of every page, for work nobody can
         see. In the customizer it was worse — Shopify re-renders the section on
         every setting change, and each render left another pair of listeners
         closed over a detached dialog that nothing ever released. */
      /* ---- and it measures AGAIN once the movement has stopped -------------
         THE LAST EVENT OF A TRANSITION IS NOT THE SETTLED ONE. iOS does not
         send a single resize when the keyboard opens, the URL bar collapses or
         a pinch-pan ends — it sends a run of them across roughly a quarter of a
         second, and the final one routinely arrives while the animation is
         still travelling. Whatever that intermediate sample says is then frozen
         onto `--hst-nl-stage-h` and `--hst-nl-stage-top`, because `.has-vv`
         drives the dialog's own top and height for the life of the page and
         nothing re-measures until the shopper happens to move the viewport
         again. A stage a hundred pixels short leaves the sheet's bottom edge
         partway up the screen with the card clipped off the top — which is the
         same picture as the bug this file has now been through three times,
         arrived at from a different direction.

         One trailing re-measure, restarted on every event so it only fires once
         the run has stopped, makes the SETTLED viewport the last word instead
         of an arbitrary frame of the animation. It re-pins the scroll offset at
         the same time, which is the other thing a keyboard transition can
         disturb on an engine without `overflow: clip`.

         300ms because the iOS keyboard and URL-bar animations are ~250ms; the
         cost is one timer that only exists while the popup is open. */
      var settleTimer = null;
      function syncStageSettling() {
        syncStage();
        if (settleTimer) window.clearTimeout(settleTimer);
        settleTimer = window.setTimeout(function () {
          settleTimer = null;
          syncStage();
          pinScroll();
        }, 300);
      }

      function listen(on) {
        if (!on && settleTimer) { window.clearTimeout(settleTimer); settleTimer = null; }
        if (!window.visualViewport) return;
        var fn = on ? 'addEventListener' : 'removeEventListener';
        /* The SETTLING wrapper is what is bound, so the same reference is
           handed to removeEventListener — binding syncStage here and removing
           the wrapper (or the reverse) would leak a listener per open. */
        window.visualViewport[fn]('resize', syncStageSettling);
        window.visualViewport[fn]('scroll', syncStageSettling);
      }

      /* ---- the dialog itself must never hold a scroll offset --------------
         THE JAVASCRIPT HALF OF THE "STICKS TO THE TOP ON AN IPHONE" FIX. Read
         the long note beside `overflow: clip` in the stylesheet for the
         mechanism; in one line: the parked sheet is a card-height of scrollable
         overflow inside a box that `overflow: hidden` made scrollable, and
         WebKit's scroll-into-view for the newly focused control runs SEVERAL
         FRAMES AFTER showModal() returns — too late for a one-shot reset — and
         drags the whole stage, and the sheet with it, up the screen.

         `overflow: clip` removes the scroll container outright and is the real
         fix. This is for the engines that do not have it (Safari 15 and
         earlier, older in-app webviews, which is a meaningful slice of
         storefront traffic): the offset is simply not allowed to be anything
         but zero for as long as the popup is open.

         It is also the general guard, not just an entrance one. Anything that
         scrolls this box is wrong by construction — the card and the story row
         are the scrollers, this is the fixed stage — so the same handler also
         catches the later ones: the engine scrolling the email field into view
         when the on-screen keyboard opens, and the thank-you swap changing the
         card's height under a focused element.

         Writing only when the value is non-zero is what keeps this from
         looping: the write fires another scroll event, that one reads zero and
         returns. `scrollLeft` is included because the same machinery scrolls
         both axes and a right-to-left storefront inverts which one is at risk.
         Re-entrancy is impossible, but the handler runs before the frame is
         painted either way, so the bad offset is never on screen. */
      function pinScroll() {
        try {
          if (dlg.scrollTop) dlg.scrollTop = 0;
          if (dlg.scrollLeft) dlg.scrollLeft = 0;
        } catch (e) {}
      }

      /* The teardown handler below needs to reach these from outside. */
      dlg.__hstNlRelease = function () {
        listen(false);
        dlg.removeEventListener('scroll', pinScroll);
        if (timer) { window.clearTimeout(timer); timer = null; }
        if (enterTimer) { window.clearTimeout(enterTimer); enterTimer = null; }
      };

      /* Mark the entrance so `will-change` is only paid for while it runs and
         so syncStage leaves the layout alone until the card has landed. */
      var card = dlg.querySelector('[data-hst-nl-card]');
      var enterTimer = null;
      function markEntering() {
        try {
          dlg.classList.add('is-entering');
          var done = function () {
            if (enterTimer) { window.clearTimeout(enterTimer); enterTimer = null; }
            dlg.classList.remove('is-entering');
            /* The card's entrance is `animation-fill-mode: both`, so it is
               parked at translateY(100%) — a full card-height BELOW the
               dialog's box — from the moment the element is displayed until
               the animation's first frame. That is real scrollable overflow in
               a box with `overflow: hidden`, and the focus step inside
               showModal() can scroll it to bring the focused element into view,
               leaving the sheet sitting a card-height off. Resetting costs
               nothing and is correct at every point it is called. */
            dlg.scrollTop = 0;
            syncStage();               /* now safe to settle the compact state */
          };
          if (card) {
            card.addEventListener('animationend', done, { once: true });
            card.addEventListener('animationcancel', done, { once: true });
          }
          /* Belt and braces: if the animation is suppressed entirely
             (prefers-reduced-motion, duration 0) no animationend ever fires.
             The handle is kept so close() can cancel it — a popup dismissed
             inside 1.2s used to leave this pending, and it then ran syncStage()
             against a dialog nobody was watching, while the keyboard was still
             retracting, and froze that half-way height onto `.has-vv`. */
          enterTimer = window.setTimeout(done, 1200);
        } catch (e) {}
      }

      function open(force) {
        try {
          if (dlg.open) return;
          opener = document.activeElement;
          listen(true);
          /* BEFORE showModal(), so the guard is already armed when the engine
             runs the dialog focusing steps. On WebKit that scroll arrives
             several frames later, which is the whole reason a one-shot reset
             was not enough. */
          dlg.addEventListener('scroll', pinScroll);
          /* Measure BEFORE the first paint, so the sheet is already in the
             right place on frame one and has nothing to correct to — and book
             the trailing re-measure at the same time, which covers the two ways
             that first reading can be the wrong one:

               * syncStage() REFUSES a nonsense measurement (height 0 from a
                 WebView that has not finished its first layout) rather than
                 freezing it on. That is right, but it means the opening frame
                 can be drawn against whatever `.has-vv` was left holding, with
                 no viewport event on the way to correct it. The settle pass is
                 that correction.
               * showModal() can itself move the visible viewport on iOS — the
                 URL bar reacts to the modal — so the measurement taken one line
                 above it is a measurement of the viewport as it was, not as the
                 shopper will see it. */
          syncStageSettling();
          if (window.visualViewport) {
            dlg.classList.toggle('is-compact', window.visualViewport.height < 520);
          }
          markEntering();
          dlg.showModal();
          dlg.scrollTop = 0;          /* see the note in markEntering() */
          /* Move focus off the close button. The platform lands on the first
             focusable child, and Chrome counts that as :focus-visible, so the
             global two-tone ring painted a heavy dark halo around the X the
             moment the popup opened. The card is tabindex="-1", so focusing it
             keeps focus inside the dialog for the tab cycle and the screen
             reader still gets the name from aria-labelledby — but nothing is
             ringed until the visitor actually tabs. */
          if (card && card.focus) { try { card.focus({ preventScroll: true }); } catch (e2) { card.focus(); } }
          if (!force) {
            var st = readState();
            st.shown = Date.now();
            writeState(st);
            /* Session mode remembers for this tab only, so closing the tab and
               coming back shows it again. */
            session('hst-nl-seen', '1');
          }
        } catch (e) {}
      }

      function close(dismissed) {
        try {
          if (timer) { window.clearTimeout(timer); timer = null; }
          if (enterTimer) { window.clearTimeout(enterTimer); enterTimer = null; }
          dlg.classList.remove('is-entering');
          /* TEARDOWN BEFORE THE GUARD, NOT AFTER IT. These used to sit below
             the `if (!dlg.open) return` and so were skipped on every path that
             reaches close() with the dialog already shut — which is not
             hypothetical: the customizer's deselect handler, a second close
             after a dismissal, and any engine that closed the dialog without
             going through here all land there. Each one left a live pair of
             visualViewport listeners and a scroll handler bound to a popup
             nobody can see, still writing geometry on every URL-bar collapse.
             Removing a listener that is not attached is a no-op, so running
             these unconditionally is free. */
          listen(false);
          dlg.removeEventListener('scroll', pinScroll);
          if (!dlg.open) return;
          dlg.close();
          if (dismissed) {
            var st = readState();
            st.shown = Date.now();
            st.dismissed = (st.dismissed || 0) + 1;
            writeState(st);
          }
          if (opener && opener.focus) opener.focus();
        } catch (e) {}
      }

      /* Handed to the customizer listeners at the bottom of the file so the
         merchant's preview goes through the same path a shopper does. */
      dlg.__hstNlOpen = open;
      dlg.__hstNlClose = close;

      /* ================= the submit =====================================
         The old build let the browser post the form and navigate. Shopify
         bounced the shopper back with `customer_posted=true`, the popup
         re-rendered in its signup state (the thank-you branch was unreachable
         — see the note by the liquid assigns), and all the shopper saw was the
         page reloading under them.

         Now the post is a fetch and there is no navigation at all. What
         Shopify does with it:

           * POST /contact  (form_type=customer)
           * on success, 302 back to the referring page with
             `customer_posted=true` on the query string. fetch follows the
             redirect, so response.url carries it and is the signal.
           * on failure, 302 back WITHOUT that flag and re-renders the page
             with the message in form.errors. We pull it out of the
             returned HTML and say it in place.

         Anything unexpected — offline, a bot challenge, a shop that answers
         some other way — falls back to a real submit, so the worst case is the
         behaviour we started with rather than a button that does nothing. */
      var form = dlg.querySelector('.hst-nl__form');
      var alertEl = dlg.querySelector('[data-hst-nl-alert]');
      var submitBtn = dlg.querySelector('[data-hst-nl-submit]');
      var field = dlg.querySelector('.hst-nl__input');

      /* Write an error where the shopper — and a screen reader — will get it.

         THE REGION IS NEVER HIDDEN. A live region has to be in the
         accessibility tree BEFORE its text changes — a node that is revealed
         and filled in the same breath has not "changed", it has appeared, and
         most screen readers say nothing at all. A blind shopper heard
         "Sending…", then silence, and was left in the field with no idea the
         address had been refused. So the <p> is always there and always live;
         it is simply empty, and CSS `:empty` keeps it from taking any space.

         The message is also tied to the field itself. Without
         aria-describedby the shopper is dropped into an input that says only
         "Email address, edit text, required" with the reason floating
         unattached above it (WCAG 3.3.1). */
      var srvErr = dlg.querySelector('[data-hst-nl-srv]');
      function say(msg) {
        if (!alertEl) return;
        /* Shopify's server-rendered error is stale the moment we have our own;
           two contradictory messages stacked above one field is worse than
           none. */
        if (srvErr && msg) srvErr.hidden = true;
        if (field) {
          if (msg) {
            field.setAttribute('aria-invalid', 'true');
            if (alertEl.id) field.setAttribute('aria-describedby', alertEl.id);
          } else {
            field.removeAttribute('aria-invalid');
            field.removeAttribute('aria-describedby');
          }
        }
        /* Straight assignment. This was briefly a reveal-then-write deferred
           through requestAnimationFrame, which is wrong twice over: rAF does
           not run in a backgrounded tab, so a shopper who submitted and
           switched apps came back to an empty error box, and it is unnecessary
           now that the region is never hidden in the first place. */
        alertEl.textContent = msg || '';
      }

      function sending(on) {
        if (!submitBtn) return;
        if (on) {
          if (!submitBtn.dataset.idle) submitBtn.dataset.idle = submitBtn.textContent;
          submitBtn.textContent = d.hstNlSending || 'Sending…';
          submitBtn.disabled = true;
          submitBtn.setAttribute('aria-busy', 'true');
        } else {
          if (submitBtn.dataset.idle) submitBtn.textContent = submitBtn.dataset.idle;
          submitBtn.disabled = false;
          submitBtn.removeAttribute('aria-busy');
        }
      }

      /* Swap the two views. The accessible name has to travel with them: the
         dialog's aria-labelledby points at one id, so that id moves to
         whichever heading is actually on screen. */
      function showView(name) {
        try {
          var views = dlg.querySelectorAll('[data-hst-nl-view]');
          for (var i = 0; i < views.length; i++) {
            views[i].hidden = views[i].getAttribute('data-hst-nl-view') !== name;
          }
          var id = dlg.getAttribute('aria-labelledby');
          if (id) {
            var heads = dlg.querySelectorAll('[data-hst-nl-heading]');
            for (var h = 0; h < heads.length; h++) {
              var owner = heads[h].closest('[data-hst-nl-view]');
              if (owner && owner.getAttribute('data-hst-nl-view') === name) {
                heads[h].id = id;
              } else if (heads[h].id === id) {
                heads[h].removeAttribute('id');
              }
            }
          }
          /* The two views are different heights. Re-measure so a phone sheet
             re-anchors to the bottom instead of leaving a gap. */
          syncStage();
        } catch (e) {}
      }

      function succeed() {
        try {
          var st = readState();
          st.subscribed = Date.now();
          writeState(st);
          session('hst-nl-seen', '1');
          session(PENDING, null);
        } catch (e) {}
        sending(false);
        say('');
        showView('done');
        /* Announce the new state and give the keyboard a sane landing spot. */
        try {
          var h = dlg.querySelector('[data-hst-nl-view="done"] [data-hst-nl-heading]');
          if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
        } catch (e) {}
      }

      /* Shopify's error markup is `.errors` (a ul of li). Read it out of the
         HTML that came back rather than guessing at the wording, so the
         shopper is told what is actually wrong. */
      function errorFrom(html) {
        try {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          /* THREE LOOKUPS, NOT ONE COMMA LIST. querySelector with a comma list
             returns the first match in DOCUMENT ORDER, not the first selector
             that matches — so on a page whose footer signup also renders an
             `.errors` block, the footer's (usually empty) node won.  The
             shopper then got the generic message instead of Shopify's actual
             reason and retyped the same address. */
          var node = doc.querySelector('#hst-nl-form .errors') ||
                     doc.querySelector('#hst-nl-form .form__message') ||
                     doc.querySelector('.errors, .form__message');
          var txt = node && node.textContent ? node.textContent.replace(/\s+/g, ' ').trim() : '';
          return txt || '';
        } catch (e) { return ''; }
      }

      function handOver() {
        /* Let the browser do it the old way. The flag is what stops the
           footer's signup from being mistaken for this one on the way back. */
        session(PENDING, '1');
        try { if (submitBtn) submitBtn.disabled = false; } catch (e) {}
        try { HTMLFormElement.prototype.submit.call(form); } catch (e) { form.submit(); }
      }

      if (form) {
        form.addEventListener('submit', function (e) {
          /* `sent` records that the request actually reached a response. It is
             the difference between "retry by navigating" and "the signup may
             already have happened" — see the catch. */
          var sent = false;
          try {
            if (!window.fetch || !window.FormData || !window.DOMParser ||
                !window.URLSearchParams || !window.Promise) {
              /* No fetch: the browser is about to navigate. Claim the post NOW,
                 or the page that comes back cannot tell this popup's signup
                 from the footer's — and the shopper gets a bare reload with no
                 thank-you and no error, which is the whole original bug. */
              session(PENDING, '1');
              return;
            }
            /* Let the browser show its own bubble for an empty or malformed
               address — it is localised and positioned for us. This path does
               not navigate, so it claims nothing. */
            if (form.checkValidity && !form.checkValidity()) return;

            e.preventDefault();
            say('');
            sending(true);

            /* ENCODE IT THE WAY THE BROWSER WOULD. Handing FormData straight
               to fetch sends multipart/form-data; a native <form> post of the
               same fields sends application/x-www-form-urlencoded. Matching
               the native encoding is the only variant Shopify's contact
               endpoint is guaranteed to accept, and a body it will not parse
               fails by subscribing nobody while looking like it worked. */
            var body = new window.URLSearchParams(new FormData(form));

            /* A STALLED REQUEST MUST NOT FREEZE THE BUTTON. A phone in a lift
               or on a captive-portal Wi-Fi can open the connection and never
               get an answer, and iOS Safari will not give up for a minute or
               more — for all of which the button reads "Sending…", is
               disabled, and is announced as busy. Twelve seconds, then abort
               and let the catch hand over to a real submit. */
            var ctrl = window.AbortController ? new window.AbortController() : null;
            var bail = ctrl ? window.setTimeout(function () {
              try { ctrl.abort(); } catch (e2) {}
            }, 12000) : null;

            window.fetch(form.action, {
              method: 'POST',
              body: body,
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Accept': 'text/html, */*'
              },
              /* 'follow' (the default) is required. 'manual' would resolve to
                 an opaqueredirect whose .url is '' and .status is 0 — no
                 signal at all. */
              redirect: 'follow',
              credentials: 'same-origin',
              signal: ctrl ? ctrl.signal : undefined
            }).then(function (res) {
              sent = true;
              if (bail) window.clearTimeout(bail);
              var url = res.url || '';
              if (url.indexOf('customer_posted=true') > -1) { succeed(); return null; }
              /* A bot challenge cannot be solved inside a fetch. Hand the
                 shopper the real page so they can answer it. */
              if (url.indexOf('/challenge') > -1) { handOver(); return null; }
              return res.text().then(function (html) {
                sending(false);
                say(errorFrom(html) || d.hstNlErr || 'Something went wrong. Please try again.');
                /* No programmatic focus on a touch device: the keyboard only
                   comes up for a focus inside a real gesture, so all this does
                   there is leave the field focused with no keyboard — and the
                   scrim handler then swallows the shopper's next tap as a
                   "dismiss the keyboard", which looks like a frozen popup. The
                   role="alert" has already spoken the message either way. */
                try {
                  if (field && field.focus &&
                      !(window.matchMedia && window.matchMedia('(pointer: coarse)').matches)) {
                    field.focus();
                  }
                } catch (e3) {}
              });
            }).catch(function () {
              if (bail) window.clearTimeout(bail);
              if (!sent) {
                /* Nothing got through — offline, blocked, aborted. Fall back to
                   a real submit so the shopper is never left with a dead
                   button. */
                handOver();
                return;
              }
              /* The server DID answer and we failed afterwards. Re-posting here
                 would submit the address a second time, which on a shop with a
                 welcome-email automation means two welcome emails and two
                 discount codes for one signup. Report it instead. */
              sending(false);
              say(d.hstNlErr || 'Something went wrong. Please try again.');
            });
          } catch (err) {
            /* A SYNCHRONOUS THROW AFTER preventDefault() IS THE WORST CASE:
               the navigation is already cancelled, so without this the shopper
               is left with a button that flips to "Sending…" and back and can
               never subscribe at all. `new URLSearchParams(new FormData())`
               needs an iterable FormData and throws on some older in-app
               webviews that do have URLSearchParams, so this is reachable. */
            try { sending(false); handOver(); } catch (e2) {}
          }
        });
      }

      /* Select the whole code on focus (this was an inline onfocus attribute;
         moved here so the markup carries no script). */
      var codeField = dlg.querySelector('[data-hst-nl-code]');
      if (codeField) {
        codeField.addEventListener('focus', function () { try { codeField.select(); } catch (e) {} });
      }

      /* Copy the code. The field is `readonly`, not `disabled`, precisely so
         the fallback works: a disabled input cannot be selected, which would
         leave a browser without the async clipboard API with no path at all. */
      var copyBtn = dlg.querySelector('[data-hst-nl-copy]');
      if (copyBtn) {
        copyBtn.addEventListener('click', function () {
          var f = dlg.querySelector('.hst-nl__code-val');
          if (!f) return;
          var flash = function () {
            var was = copyBtn.textContent;
            copyBtn.textContent = copyBtn.dataset.copied || 'Copied';
            window.setTimeout(function () { copyBtn.textContent = was; }, 2000);
          };
          try {
            if (navigator.clipboard && navigator.clipboard.writeText) {
              navigator.clipboard.writeText(f.value).then(flash, function () { f.select(); });
            } else { f.select(); flash(); }
          } catch (e) { try { f.select(); } catch (e2) {} }
        });
      }

      /* Close controls. `cancel` covers ESC, which the platform fires for us. */
      var closers = dlg.querySelectorAll('[data-hst-nl-close]');
      for (var c = 0; c < closers.length; c++) {
        closers[c].addEventListener('click', function () { close(true); });
      }
      dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(true); });

      /* Click outside the card. The dialog fills the viewport, so a click that
         lands on the dialog or the stage — but not inside the card — is a
         backdrop click. */
      dlg.addEventListener('click', function (e) {
        var onScrim = e.target === dlg ||
          (e.target.classList && e.target.classList.contains('hst-nl__stage'));
        if (!onScrim) return;
        /* On a phone the gesture for putting the keyboard away is a tap on
           whatever sits above it — which here is the scrim. Closing on that
           throws away a half-typed address, so the first such tap only blurs.

           THE TEST IS FOCUS, NOT CONTENT. It used to also count a non-empty
           field, which meant that once the shopper had typed anything the
           scrim could never close the popup at all: every tap blurred an
           already-blurred field and returned. Tapping outside twice — once to
           dismiss the keyboard, once to dismiss the popup — now works, and a
           shopper who has typed an address and changed their mind is no longer
           stuck with only the X. */
        if (field && document.activeElement === field) {
          if (field.blur) field.blur();
          return;
        }
        close(true);
      });

      /* ---- SUCCESS FIRST ------------------------------------------------
         Only reached on the fallback path, where a real submit navigated. The
         two conditions must BOTH hold: Shopify says a customer form posted,
         AND this popup is the one that posted it. Without the second test the
         footer's newsletter signup would throw this popup open, thank the
         shopper for subscribing, and interrupt the page they were reading. */
      var posted = window.location.search.indexOf('customer_posted=true') > -1;
      if (posted) {
        /* Two independent signals that this popup is the form that posted, so
           a browser with sessionStorage blocked still gets it right:

             * the flag written just before handing over, and
             * the fragment. Shopify renders the form's action as
               `/contact#hst-nl-form` (the footer's is `#ContactFooter`), and
               a 302 whose Location carries no fragment preserves the request's
               own — so the hash on the way back names the form that posted. */
        var mine = session(PENDING) === '1' || window.location.hash === '#hst-nl-form';
        session(PENDING, null);
        /* BOTH signals have to be one-shot. The flag is consumed above, but the
           hash stays in the URL — so pressing Back to this page, refreshing it,
           or opening it from history re-opened the thank-you modal over the
           page every single time. Rewriting the URL retires the hash and also
           takes `customer_posted=true` off anything the shopper copies. */
        try {
          if (window.history && history.replaceState) {
            /* Drop ONLY `customer_posted` and the fragment. Replacing the whole
               query would throw away utm_* and every other attribution
               parameter the shopper arrived with, and Shopify's own analytics
               reads those on later navigations. */
            var qs = window.location.search.replace(/^\?/, '').split('&')
              .filter(function (kv) { return kv && kv.split('=')[0] !== 'customer_posted'; })
              .join('&');
            history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : ''));
          }
        } catch (e4) {}
        /* They are on the list either way — never ask a subscriber again. */
        try {
          var sub = readState();
          sub.subscribed = Date.now();
          writeState(sub);
          session('hst-nl-seen', '1');
        } catch (e2) {}
        if (mine) {
          showView('done');
          open(true);          /* `force` keeps this out of the frequency count */
        }
        return;
      }

      /* The other half of the fallback path: Shopify REJECTED the address. It
         redirects back with no `customer_posted` flag and re-renders the form
         with the reason inside it. That markup is useless in a dialog that is
         never opened — `:not([open])` is display:none — which is why a bad
         address used to look exactly like a good one: a reload, and nothing.
         If our own submit is the one that came back, open on the message. */
      if (session(PENDING) === '1' || window.location.hash === '#hst-nl-form') {
        session(PENDING, null);
        var srvText = srvErr && srvErr.textContent ? srvErr.textContent.trim() : '';
        if (srvText) {
          srvErr.hidden = false;          /* ours, so it is safe to show */
          if (field) {
            field.setAttribute('aria-invalid', 'true');
            field.setAttribute('aria-describedby', srvErr.id || '');
            if (!srvErr.id) field.removeAttribute('aria-describedby');
          }
          showView('signup');
          open(true);
          if (field && field.focus) { try { field.focus({ preventScroll: true }); } catch (e3) {} }
          return;
        }
      }

      /* Never ask a subscriber to subscribe — but not FOREVER. This was a
         bare truth test on a key that is never cleared and has no expiry, and
         it is written for a success on ANY customer form on the page: the
         footer signup and the newsletter section post to the same endpoint.
         So a merchant who tested their own footer field once could never see
         their popup again on that machine and reported it as broken, and a
         merchant launching a new offer could not re-invite anyone who had
         signed up a year earlier. It is stored as a timestamp already, so
         compare it instead of truth-testing it. */
      var sub0 = readState().subscribed;
      if (sub0 && (Date.now() - sub0) < days(parseInt(d.hstNlSubDays, 10) || 365)) return;

      /* The customizer: opening on top of the merchant's canvas every time
         they change a setting makes the section impossible to edit. They can
         still see it — Shopify selects the section and fires the event below. */
      if (d.hstNlEditor === 'true') return;

      /* ---- suppression --------------------------------------------------- */
      if (d.hstNlMobile !== 'true' && window.matchMedia('(max-width: 767px)').matches) return;

      /* Strip a locale prefix once, then match. Without this every rule below
         was wrong on a localised storefront: `/en-gb/cart` does not start with
         `/cart`, so the popup interrupted checkout, and `/fr/collections/all`
         was treated as the home page. */
      var path = window.location.pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/|$)/i, '') || '/';

      if (d.hstNlScope === 'home' && path !== '/') return;

      /* Never interrupt someone who is already buying. */
      var excl = (d.hstNlExclude || '').split(',');
      for (var x = 0; x < excl.length; x++) {
        var p = excl[x].trim();
        if (p && path.indexOf(p) === 0) return;
      }

      /* ---- how often ------------------------------------------------------
         always  — every visit, including a reload. Nothing is remembered, so
                   closing the tab and coming back shows it again.
         session — once per tab. Survives navigation within the visit, forgets
                   when the tab closes (sessionStorage is per-tab by
                   definition, which is exactly the semantics wanted).
         days    — once every N days, with dismissal decay, across visits.   */
      var mode = d.hstNlFreq || 'session';

      if (mode === 'session') {
        if (session('hst-nl-seen')) return;
      } else if (mode === 'days') {
        var st2 = readState();
        var maxD = parseInt(d.hstNlMax, 10) || 0;
        var silence = parseInt(d.hstNlSilence, 10) || 0;

        /* Dismissal decay: after N dismissals it goes quiet for a long stretch
           rather than nagging forever. */
        if (maxD > 0 && (st2.dismissed || 0) >= maxD) {
          if (!silence || (Date.now() - (st2.shown || 0)) < days(silence)) return;
          /* Clear the CLOCK as well as the counter. Resetting only the count
             left `shown` at the last dismissal, so the very next test — "has
             frequency_days passed?" — still returned. With silence_days 30 and
             frequency_days 60 the popup did not come back at day 30 as the
             setting promises; it came back at day 60, and because the counter
             was now 0 the decay branch never ran again to explain why. */
          st2.dismissed = 0;
          st2.shown = 0;
          writeState(st2);
        }
        if (st2.shown && (Date.now() - st2.shown) < days(parseInt(d.hstNlDays, 10) || 0)) return;
      }

      var delay = (parseFloat(d.hstNlDelay) || 0) * 1000;
      /* WAIT FOR THE SHOPPER TO BE FREE. If the theme already has the mobile
         nav drawer or one of its own modals up when the timer fires, opening
         here is doubly wrong: showModal() makes the whole rest of the document
         inert, so the menu behind the scrim goes completely dead — its links
         and its own close button stop responding and it reads as "the menu
         broke" — and the impression is spent, because open(false) records it
         and the default "once per visit" then never shows it again.

         The class names are the vendor bundle's own (assets/theme.js:679 and
         :864). Re-queue rather than cancel, so the invitation still arrives
         once they are done. `pagehide` and close() both clear `timer`, so
         nothing is left running. */
      var fire = function () {
        try {
          var bodyCls = document.body ? document.body.className : '';
          var rootCls = document.documentElement.className;
          var cls = bodyCls + ' ' + rootCls;
          if (cls.indexOf('js-drawer-open') > -1 || cls.indexOf('modal--is-active') > -1) {
            timer = window.setTimeout(fire, 1000);
            return;
          }
        } catch (e) {}
        open(false);
      };
      timer = window.setTimeout(fire, delay);

      /* A pending timer must not outlive the page it was scheduled on, or the
         popup opens over whatever the shopper navigated to next. */
      window.addEventListener('pagehide', function () {
        if (timer) { window.clearTimeout(timer); timer = null; }
      });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  /* The theme editor swaps sections in and out. */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  /* Clicking the section in the customizer's sidebar is how the merchant asks
     to look at it, since the auto-open is suppressed in design mode. */
  document.addEventListener('shopify:section:select', function (e) {
    try {
      var dlg = e.target.querySelector ? e.target.querySelector('[data-hst-nl]') : null;
      /* Drive the REAL opener, not showModal(). A raw showModal() skipped
         syncStage() — so `has-vv` was never added and the merchant styled the
         popup against a fallback geometry no shopper gets — skipped the
         compact toggle, so the short-viewport layout could not be previewed at
         all in the customizer's phone pane, and skipped the focus move, so
         Chrome painted the heavy global ring around the close button. `true`
         keeps the merchant's preview out of the frequency count. */
      if (dlg && !dlg.open && dlg.__hstNlOpen) dlg.__hstNlOpen(true);
    } catch (err) {}
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    try {
      var dlg = e.target.querySelector ? e.target.querySelector('[data-hst-nl]') : null;
      /* close(false): closing a PREVIEW is not a dismissal. The raw close()
         here used to increment the merchant's own dismissal counter in their
         real storefront localStorage every time they clicked away. */
      if (dlg && dlg.open && dlg.__hstNlClose) dlg.__hstNlClose(false);
    } catch (err) {}
  });
  /* Shopify tears the old section down on every setting change. Without this
     each edit left another pair of visualViewport listeners and a live timer
     closed over a detached dialog, and the customizer preview degraded the
     longer the merchant worked. */
  document.addEventListener('shopify:section:unload', function (e) {
    try {
      var dlg = e.target.querySelector ? e.target.querySelector('[data-hst-nl]') : null;
      if (dlg && dlg.__hstNlRelease) dlg.__hstNlRelease();
    } catch (err) {}
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hst-quotes"] && !Shopify.designMode) return;
  try {
    
/* hst-quotes — keep the scroll pips in step with the rail.
   Pure enhancement: the active pip is already correct in the server render, so
   if this bundle never runs (or an earlier section throws) the section still
   matches the design exactly. Everything is wrapped so a failure here cannot
   take out the sections that follow. */
(function () {
  var ROOT_SEL = '.hst-quotes[data-hst-quotes]';
  var ON = 'hst-quotes-dot--on';

  function sync(root) {
    var rail = root.querySelector('[data-hst-quotes-rail]');
    var dots = root.querySelectorAll('[data-hst-quotes-dot]');
    if (!rail || dots.length < 2) return;
    var span = rail.scrollWidth - rail.clientWidth;
    var frac = span > 1 ? rail.scrollLeft / span : 0;
    if (frac < 0) frac = 0;
    if (frac > 1) frac = 1;
    var active = Math.round(frac * (dots.length - 1));
    for (var i = 0; i < dots.length; i++) {
      if (i === active) dots[i].classList.add(ON);
      else dots[i].classList.remove(ON);
    }
  }

  function bind(root) {
    if (root.getAttribute('data-hst-quotes-bound') === 'on') return;
    var rail = root.querySelector('[data-hst-quotes-rail]');
    if (!rail) return;
    root.setAttribute('data-hst-quotes-bound', 'on');

    var queued = false;
    function schedule() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        sync(root);
      });
    }
    rail.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    sync(root);
  }

  function init(scope) {
    try {
      var nodes = (scope || document).querySelectorAll(ROOT_SEL);
      for (var i = 0; i < nodes.length; i++) bind(nodes[i]);
    } catch (e) { /* never break the shared bundle */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
  const getpagi = document.querySelector('.AjaxinatePagination');
  if (typeof getpagi !== 'undefined' && getpagi !== null) {
    document.addEventListener('DOMContentLoaded', function () {
      const elem = getpagi.getAttribute('data-pagination');
      var endlessScroll = new Ajaxinate({
        container: '.AjaxinateLoop',
        pagination: '.AjaxinatePagination',
        loadingText: '<span class="loader-line"></span>',
        method: elem == 'scroll' ? 'scroll' : 'click',
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-content"]) return;
  try {
    
  class productPairs extends HTMLElement {
    connectedCallback() {
      fetch(this.dataset.url).
      then((response) => {
        if (!response.ok) {
          throw new Error("HTTP error! Status: ".concat(response.status));
        }
        return response.text();
      }).
      then((response) => {
        var frag = document.createDocumentFragment(),
          fetchedContent = document.createElement('div');
        frag.appendChild(fetchedContent);
        fetchedContent.innerHTML = response;

        var replacementContent = fetchedContent.querySelector("[data-id=\"".concat(CSS.escape(this.dataset.id), "\"]"));
        if (replacementContent) {
          this.innerHTML = replacementContent.innerHTML;
        }
      });
    }
  }

  customElements.define('product-pairs', productPairs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
 
class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
              const swiperContainer = this.querySelector('.swiper-container');
              const getID = swiperContainer.getAttribute("data-id");
              const swiperID = this.querySelector(`.swipercol-${getID}`);
              const spaceBetween = parseInt(swiperContainer.getAttribute('data-space-between'), 10);
              const perviewDesktop = swiperContainer.getAttribute('data-perview-desktop');
              if (swiperContainer) {
                new Swiper(swiperContainer, {
                  slidesPerView: "auto",
                  freeMode: false,
                  autoHeight: true,
                  calculateHeight:true,
                  freeModeSticky: true,
                  centeredSlides: false,
                  grabCursor: true,
                  watchSlidesVisibility: true,
                  watchSlidesProgress: true,
                  preloadImages: true,
                  updateOnImagesReady: true,
                  spaceBetween: spaceBetween,
                  observer: true,
                  observeParents: true,
                  parallax:true,
                  a11y: true,
                  keyboard: {
                    enabled: true,
                  },
                  breakpoints: {
                    320: {
                      slidesPerView: 2,
                      spaceBetween: 20
                    },
                    576: {
                      slidesPerView: 2,
                    },
                    768: {
                      slidesPerView: 3,
                    },
                    992: {
                      slidesPerView: perviewDesktop,
                    }
                  },
                  scrollbar: {
                    el: this.querySelector(".swiper-scrollbar"),
                  },
                  navigation: {
                    nextEl: this.querySelector(".swiper-button-next"),
                    prevEl: this.querySelector(".swiper-button-prev"),
                  },
                });
              } else {
                console.error('No element with class "swiper-container" found.');
              }
            }
            if (window.SPR && theme.review ) {
              if ($('.shopify-product-reviews-badge').length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              };
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    
  class productPairsRight extends HTMLElement {
    connectedCallback() {
      fetch(this.dataset.url)
        .then((response) => {
          if (!response.ok) {
            throw new Error('HTTP error! Status: '.concat(response.status));
          }
          return response.text();
        })
        .then((response) => {
          var frag = document.createDocumentFragment(),
            fetchedContent = document.createElement('div');
          frag.appendChild(fetchedContent);
          fetchedContent.innerHTML = response;

          var replacementContent = fetchedContent.querySelector('[data-id="'.concat(CSS.escape(this.dataset.id), '"]'));
          if (replacementContent) {
            this.innerHTML = replacementContent.innerHTML;
          }
        });
    }
  }

  customElements.define('product-pairsright', productPairsRight);

  class BuyNow extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', this.handleClick.bind(this));
    }

    connectedCallback() {
      this.checkAgreement();
    }

    handleClick(event) {
      const agreeCheckbox = this.querySelector('.checkbox__input');
      const checkoutButton = this.querySelector('.product-form__buynow');

      if (event.target === agreeCheckbox || event.target === this.querySelector('.checkbox__label')) {
        if (agreeCheckbox.checked) {
          checkoutButton.classList.remove('disabled');
        } else {
          checkoutButton.classList.add('disabled');
        }
      }
    }
    checkAgreement() {
      const agreeCheckbox = this.querySelector('.checkbox__input');
      return agreeCheckbox.checked;
    }
  }

  customElements.define('buy-now', BuyNow);

  var initPhotoSwipeFromDOM = function (gallerySelector) {
    // parse slide data (url, title, size ...) from DOM elements
    // (children of gallerySelector)
    var parseThumbnailElements = function (el) {
      var thumbElements = Array.prototype.slice.call(document.querySelectorAll('.photo-image')),
        numNodes = thumbElements.length,
        items = [],
        figureEl,
        linkEl,
        size,
        item;

      for (var i = 0; i < numNodes; i++) {
        figureEl = thumbElements[i]; // <figure> element
        // include only element nodes
        if (figureEl.nodeType !== 1) {
          continue;
        }

        linkEl = figureEl.children[0]; // <a> element
        if (linkEl.getAttribute('data-size')) {
          size = linkEl.getAttribute('data-size').split('x');
        } else {
          size = [];
        }

        // create slide object
        item = {
          src: linkEl.getAttribute('href'),
          w: parseInt(size[0], 10),
          h: parseInt(size[1], 10),
        };

        if (figureEl.children.length > 1) {
          // <figcaption> content
          item.title = figureEl.children[1].innerHTML;
        }

        if (linkEl.children.length > 0) {
          // thumbnail element, retrieving thumbnail url
          item.msrc = linkEl.children[0].getAttribute('data-phototview');
        }

        item.el = figureEl; // save link to element for getThumbBoundsFn
        items.push(item);
      }

      return items;
    };

    // find nearest parent element
    var closest = function closest(el, fn) {
      return el && (fn(el) ? el : closest(el.parentNode, fn));
    };

    // triggers when user clicks on thumbnail
    var onThumbnailsClick = function (e) {
      e = e || window.event;
      e.preventDefault ? e.preventDefault() : (e.returnValue = false);

      var eTarget = e.target || e.srcElement;

      // find root element of slide
      var clickedListItem = closest(eTarget, function (el) {
        return el.tagName && el.tagName.toUpperCase() === 'FIGURE';
      });

      if (!clickedListItem) {
        return;
      }

      // find index of clicked item by looping through all child nodes
      // alternatively, you may define index via data- attribute
      var clickedGallery = clickedListItem.parentNode,
        childNodes = clickedListItem.parentNode.childNodes,
        numChildNodes = childNodes.length,
        nodeIndex = 0,
        index;

      for (var i = 0; i < numChildNodes; i++) {
        if (childNodes[i].nodeType !== 1) {
          continue;
        }

        if (childNodes[i] === clickedListItem) {
          index = nodeIndex;
          break;
        }
        nodeIndex++;
      }

      if (index >= 0) {
        // open PhotoSwipe if valid index found
        openPhotoSwipe(index, clickedGallery);
      }
      return false;
    };

    // parse picture index and gallery index from URL (#&pid=1&gid=2)
    var photoswipeParseHash = function () {
      var hash = window.location.hash.substring(1),
        params = {};

      if (hash.length < 5) {
        return params;
      }

      var vars = hash.split('&');
      for (var i = 0; i < vars.length; i++) {
        if (!vars[i]) {
          continue;
        }
        var pair = vars[i].split('=');
        if (pair.length < 2) {
          continue;
        }
        params[pair[0]] = pair[1];
      }

      if (params.gid) {
        params.gid = parseInt(params.gid, 10);
      }

      return params;
    };

    var openPhotoSwipe = function (index, galleryElement, disableAnimation, fromURL) {
      var pswpElement = document.querySelectorAll('.pswp')[0],
        gallery,
        options,
        items;

      items = parseThumbnailElements(galleryElement);

      // define options (if needed)
      options = {
        maxSpreadZoom: 1,
        bgOpacity: 0.7,
        zoomEl: true,
        history: false,
        pinchToClose: false,
        closeOnScroll: false,

        // define gallery index (for URL)
        galleryUID: galleryElement.getAttribute('data-pswp-uid'),
      };

      // PhotoSwipe opened from URL
      if (fromURL) {
        if (options.galleryPIDs) {
          // parse real index when custom PIDs are used
          // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
          for (var j = 0; j < items.length; j++) {
            if (items[j].pid == index) {
              options.index = j;
              break;
            }
          }
        } else {
          // in URL indexes start from 1
          options.index = parseInt(index, 10) - 1;
        }
      } else {
        options.index = parseInt(index, 10);
      }

      // exit if index not found
      if (isNaN(options.index)) {
        return;
      }

      if (disableAnimation) {
        options.showAnimationDuration = 0;
      }

      // Pass data to PhotoSwipe and initialize it
      gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
      gallery.init();
    };

    // loop through all gallery elements and bind events
    var galleryElements = document.querySelectorAll(gallerySelector);

    for (var i = 0, l = galleryElements.length; i < l; i++) {
      galleryElements[i].setAttribute('data-pswp-uid', i + 1);
      galleryElements[i].onclick = onThumbnailsClick;
    }

    // Parse URL and open gallery if it contains #&pid=3&gid=1
    var hashData = photoswipeParseHash();
    if (hashData.pid && hashData.gid) {
      openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
    }
  };


    document.addEventListener('DOMContentLoaded', function () {
        const swiper = new Swiper('.my-gallery', {
          effect: 'slide',
          spaceBetween: 5,
          slidesPerView: 1.008,
          speed: 600,
          loop: false,
          allowTouchMove: true,

          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          on: {
            slideChange() {
              // add active to the current slide
              const index = this.activeIndex;
              updateActiveSlide(index, thumbsSwiper);
            },
          },
          breakpoints: {
            576: {
              slidesPerView: 1,
            },
          },
        });

      const thumb_slider = document.querySelector('.thumb-container');

      // Thumbnail Swiper
      const thumbsSwiper = new Swiper('.thumbs-swiper', {
        init: false,
        slidesPerView: 5.6,
        spaceBetween: 5,
        navigation: {
          nextEl: '.thumbs-next',
          prevEl: '.thumbs-prev',
        },
        breakpoints: {
          576: {
            slidesPerView: 6,
          },
        },
      });

      thumbsSwiper.init();

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          thumbsSwiper.update();
          thumb_slider.classList.add('ready');
        });
      });

      const slides = document.querySelectorAll('.thumbs-swiper .swiper-slide');
      let activeIndex = 0;

      // Function to update active class
      function updateActiveSlide(index, _swiperToUpdate) {
        slides.forEach((s) => s.classList.remove('carousel-active'));
        if (slides[index]) {
          slides[index].classList.add('carousel-active');
          if (_swiperToUpdate) {
            _swiperToUpdate.slideTo(index);
          } else {
            swiper.slideTo(index);
          }
        }
      }

      // INITIAL ACTIVE
      updateActiveSlide(activeIndex);

      // CLICK ON THUMBNAILS
      slides.forEach((slide, index) => {
        slide.addEventListener('click', () => {
          activeIndex = index;
          updateActiveSlide(activeIndex);
        });
      });

      function nextFn() {
        if (activeIndex < slides.length - 1) {
          activeIndex++;
        }
        updateActiveSlide(activeIndex);
      }

      function prevFn() {
        if (activeIndex > 0) {
          activeIndex--;
        }
        updateActiveSlide(activeIndex);
      }

      function nextMainFn() {
        if (activeIndex < slides.length - 1) {
          activeIndex++;
        }
        updateActiveSlide(activeIndex, thumbsSwiper);
      }

      function prevMainFn() {
        if (activeIndex > 0) {
          activeIndex--;
        }
        updateActiveSlide(activeIndex, thumbsSwiper);
      }

      // NEXT BUTTON
      document.querySelector('.thumbs-next').addEventListener('click', nextFn);
      document.querySelector('.my-gallery .swiper-button-next').addEventListener('click', nextMainFn);

      // PREV BUTTON
      document.querySelector('.thumbs-prev').addEventListener('click', prevFn);
      document.querySelector('.my-gallery .swiper-button-prev').addEventListener('click', prevMainFn);
  });

  // execute above function
  initPhotoSwipeFromDOM('.my-gallery');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-videos"] && !Shopify.designMode) return;
  try {
    
class KsShoppableVideos extends HTMLElement {
  constructor () {
    super()

    if (!document.querySelector('#swiper-stylesheet')) {
      const stylesheet = document.createElement('link')
      stylesheet.setAttribute('href', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.css')
      stylesheet.setAttribute('rel', 'stylesheet')
      stylesheet.setAttribute('id', 'swiper-stylesheet')
      stylesheet.setAttribute('integrity', 'sha256-5nkrwjVsiNfKz3NR1k2h5+qt5pS5SF2u9/TIT1hElow=')
      stylesheet.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(stylesheet)
    }

    if (!document.querySelector('#swiper-script')) {
      const script = document.createElement('script')
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.js')
      script.setAttribute('id', 'swiper-script')
      script.setAttribute('integrity', 'sha256-rCACDWCp/VzIh0rsB+ipQCM9XBvO8HNe0fNSOa4sys0=')
      script.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(script)
    }

    setTimeout(() => {
      const slider = new window.Swiper(this.querySelector('.swiper'), this.splideOptions())

      slider.on('slideChange', () => {
        this.querySelector('.swiper').classList.add('swiper-is-changing')
        this.onSlideChange()
      })

      slider.on('slideChangeTransitionEnd', () => {
        this.querySelector('.swiper').classList.remove('swiper-is-changing')
      })
    }, 500)

    this.querySelectorAll('.ks-shoppable-videos-btn-play').forEach(btn => {
      btn.addEventListener('click', () => {
        const video = btn.closest('.ks-shoppable-videos-video-wrapper').querySelector('video')
        this.onVideoPlay(video)
      })
    })

    this.querySelectorAll('video').forEach(video => {
      video.addEventListener('click', () => {
        this.onVideoPlay(video)
      })
    })

    const lazyVideosObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.play()
        }
      })
    }, { rootMargin: '0px 0px 300px 0px' })
    
    this.querySelectorAll('video[data-autoplay="true"]').forEach((el) => {
      lazyVideosObserver.observe(el)
    })
  }

  splideOptions () {
    const partialSlidesMobile = this.dataset.partialSlidesMobile === 'true' ? 1.2 : 1

    /** @type {SwiperOptions} */
    const options = {
      rewind: true,
      speed: Number(this.dataset.sliderSpeed),
      breakpoints: {
        0: { slidesPerView: Number(this.dataset.breakpointXs) * partialSlidesMobile },
        576: { slidesPerView: Number(this.dataset.breakpointSm) },
        768: { slidesPerView: Number(this.dataset.breakpointMd) },
        992: { slidesPerView: Number(this.dataset.breakpointLg) },
        1200: { slidesPerView: Number(this.dataset.breakpointXl) },
        1400: { slidesPerView: Number(this.dataset.breakpointXxl) }
      },
      navigation: {
        enabled: this.dataset.sliderNav === 'true',
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      },
      pagination: {
        enabled: this.dataset.sliderPagination === 'true',
        type: this.dataset.sliderPaginationType,
        el: '.swiper-pagination',
        dynamicBullets: true,
        dynamicMainBullets: 2,
        renderFraction: function (currentClass, totalClass) {
          return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
        }
      },
      scrollbar: {
        enabled: this.dataset.sliderScrollbar === 'true',
        el: this.querySelector('.swiper-scrollbar'),
        draggable: true 
        // hide: true
      },
      autoplay: this.dataset.sliderAutoplay !== '0'
        ? { delay: Number(this.dataset.sliderAutoplay) * 1000 }
        : undefined,
      watchSlidesProgress: true, 
      mousewheel: {
        enabled: true,
        forceToAxis: true
      },
    }
    return options
  }

  onSlideChange () {
    this.querySelectorAll('.ks-shoppable-videos-card').forEach(elem => {
      elem.setAttribute('data-is-playing', 'false')
      elem.querySelector('video')?.pause()
    })
  }

  onVideoPlay (video) {
    const card = video.closest('.ks-shoppable-videos-card')

    this.querySelectorAll('.ks-shoppable-videos-card').forEach(elem => {
      if (elem.dataset.index !== card.dataset.index) {
        elem.setAttribute('data-is-playing', 'false')
        elem.querySelector('video')?.pause()
      }
    })
    
    if (card.dataset.isPlaying === 'true') {
      card.setAttribute('data-is-playing', 'false')
      video.pause()
    } else {
      card.setAttribute('data-is-playing', 'true')
      video.muted = false
      video.play()
    }
  }

}
customElements.define('ks-shoppable-videos', KsShoppableVideos)


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
  !function(){function e(e){this.element=e,this.blocks=this.element.getElementsByClassName("js-cd-block"),this.images=this.element.getElementsByClassName("js-cd-img"),this.contents=this.element.getElementsByClassName("js-cd-content"),this.offset=.8,this.hideBlocks()}e.prototype.hideBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.blocks[e].getBoundingClientRect().top>window.innerHeight*t.offset&&(t.images[e].classList.add("cd-is-hidden"),t.contents[e].classList.add("cd-is-hidden"))},e.prototype.showBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.contents[e].classList.contains("cd-is-hidden")&&t.blocks[e].getBoundingClientRect().top<=window.innerHeight*t.offset&&(t.images[e].classList.add("or-timeline__img--bounce-in"),t.contents[e].classList.add("or-timeline__content--bounce-in"),t.images[e].classList.remove("cd-is-hidden"),t.contents[e].classList.remove("cd-is-hidden"))};var t,s=document.getElementsByClassName("js-or-timeline"),n=[],i=!1;if(s.length>0){for(var o=0;o<s.length;o++)t=o,n.push(new e(s[t]));window.addEventListener("scroll",function(e){i||(i=!0,window.requestAnimationFrame?window.requestAnimationFrame(c):setTimeout(c,250))})}function c(){n.forEach(function(e){e.showBlocks()}),i=!1}}();

  } catch(e) { console.error(e); }
})();
})();
